export default "__VITE_ASSET__192607b5__"